export default __webpack_public_path__ + "static/media/next_class_icon.128e5f23.svg";